import React from "react";
import { Link } from "react-router-dom";
import { SERVICE_PAGE_SLUGS } from "../../../services/contentApi";
import "./ServicesDropDown.css";

export { SERVICE_PAGE_SLUGS };

export const SERVICES_DROPDOWN_ITEMS = [
  {
    title: "Design",
    desc: "UI/UX that connects users with products",
    to: "/design",
  },
  {
    title: "Development",
    desc: "High-performance web platforms",
    to: "/development",
  },
  {
    title: "Engineering",
    desc: "Custom software built to scale",
    to: "/engineering",
  },
  {
    title: "Transformation",
    desc: "Evolve your business through technology",
    to: "/transformation",
  },
  {
    title: "AI",
    desc: "Smart systems powered by data",
    to: "/ai",
  },
  {
    title: " Cloud & Infrastructure",
    desc: "Reliable systems built for scale",
    to: "/infrastructure",
  },
];

const ServicesDropDown = () => {
  return (
    <div className="services-dropdown">
      <div className="services-dropdown__inner">
        {SERVICES_DROPDOWN_ITEMS.map((item, index) =>
          item.to ? (
            <Link
              key={index}
              to={item.to}
              className={`servicedrop-card ${item.active ? "active" : ""}`}
            >
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </Link>
          ) : (
            <div
              key={index}
              className={`servicedrop-card ${item.active ? "active" : ""}`}
            >
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ServicesDropDown;
